<button [class]="'mapfre-button ' + classList + ' size-' + size" [ngClass]="{
    'outline-primary': type ==='outline-primary',
    'link-primary': type ==='link-primary',
    'primary': type ==='primary',
    'clear-primary': type ==='clear-primary',
    'disabled':disabled,
    'clear': type ==='clear',
    'dark': type ==='dark',
    'transparent': type ==='transparent',
    'transparent-white': type ==='transparent-white',
    'outline': type ==='outline',
    'icon': icon
  }" [style.font-size]="fs + 'px'" [style.font-weight]="fw" [style.background]="background" [style.color]="color"
  [style.margin-top]="mt + 'px'" [style.margin-left]="ml + 'px'" [style.margin-right]="mr + 'px'"
  [style.width]="pixelWidth + 'px'" [style.width]="perWidth + '%'" mat-stroked-button primary>
  <!-- [icon] name svg inside assets/icons folder -->
  <img *ngIf="icon && slot === 'start'" [src]="'assets/icons/' + icon + '.svg'" alt="">
  {{text}}
  <img *ngIf="icon && slot === 'end'" [src]="'assets/icons/' + icon + '.svg'" alt="">
</button>
